import React, { useCallback, useEffect, useRef, useState } from "react";
import BpmnModeler from "@uniphore/a8-bpmn-modeler/lib/Modeler";
import propertiesPanelModule from '@uniphore/a8-bpmn-properties-panel';
import propertiesProviderModule from '@uniphore/a8-bpmn-properties-panel/lib/provider/camunda';
import camundaModdleDescriptor from "camunda-bpmn-moddle/resources/camunda.json";
import { getBusinessObject } from "@uniphore/a8-bpmn-modeler/lib/util/ModelUtil.js";
import "@uniphore/a8-bpmn-modeler/lib/assets/diagram-js.css";
import "@uniphore/a8-bpmn-modeler/lib/assets/bpmn-font/css/bpmn-embedded.css";
import { initialDiagram } from './initialBpmn';
import './bpmn.sass'
import { onBpmnAction } from '../../../../../stateManager/store/common/action';
import { Http } from "../../../../../helpers/axois";
import "./css/app.css"
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { AppState } from "../../../../../stateManager/store";
import { FormModal } from './BpmnProperties/FormModal'
import { ServiceModal } from './BpmnProperties/serviceModal'
import { SoloModal } from "./BpmnProperties/soloFlowsModal"
import { useToast, redirectOnError } from "../../../../../helpers/commonFunction";
//import { pushToast } from '../../../../stateManager/store/toast/actions'
import { ResourceLock } from '../../../../../helpers/RxServices'
import { logger } from "../../../../../constant/winston";
import { selectedServices, selectedSolo, selectedJourney } from "../../../../../stateManager/store/solo/action";
import { parseString, Builder } from "xml2js";
import { updateSelectedBpmn } from "../../../../../stateManager/store/apps/actions";
import lintModule from 'bpmn-js-bpmnlint';
import 'bpmn-js-bpmnlint/dist/assets/css/bpmn-js-bpmnlint.css';
import { BPMNTars, BPMNXMLStack } from './tars'
import bpmnlintConfig from "../../../../../packed-config"
import { setStepIndex } from "../../../../../stateManager/store/onboarding/action";
import { store } from "../../../../../stateManager";
import { AgentListModal } from "../../../common/agentModal";
import ActionModal from "../../../common/actionModal";
import { ActionDetails } from "../../../Solo/soloJourney/create";
interface Iprops {
    match: any;
    history: any;
    appVersion?: { currentVersion: boolean, versionId: string };
    //pushToast: (data: any) => void;
    selectedBranch?: any;
    bpmnModelerInstance: any;
    onBpmnAction?: any;
}
interface Istate {
    bpmndata: any[],
    visible: boolean,
    formKey: string,
    userTaskId: string
    serviceVisible: boolean
    servicekey: string
    serviceTaskId: string
}

const Assist = (props: Iprops, state: Istate) => {
    let bpmnModelerInstance = props.bpmnModelerInstance;
    let bpmnModeler: any = useRef(null);
    const [visible, setvisible] = useState<boolean>(false);
    const [bpmndata, setbpmndata] = useState<any>([]);
    const [formKey, setformKey] = useState("");
    const [userTaskId, setuserTaskId] = useState("");
    const [servicekey, setservicekey] = useState("");
    const [serviceTaskId, setserviceTaskId] = useState("");
    const [serviceVisible, setserviceVisible] = useState<boolean>(false);
    const params: any = props.match.params;
    const history = useHistory();
    const { bpmnId, appId } = params;
    const bpmnActionType = useSelector((state: any) => state.common.bpmnActionType)
    const appVersion = useSelector((state: AppState) => state.apps.appVersion && state.apps.appVersion[appId]);
    const selectedBranch = useSelector((state: AppState) => state.apps.appBranch);
    const versionId = appVersion && appVersion.versionId;
    const previousVersionId = appVersion && appVersion.previousVersionId
    const branchId = selectedBranch && selectedBranch[appId] && selectedBranch[appId].branchId;
    const currentVersion = appVersion && appVersion.currentVersion;
    const { ErrorToast, SuccessToast } = useToast()
    const dispatch = useDispatch();
    const [resourceLock, setResourceLock] = useState<any>({})
    const [loadedBPMNModeler, setLoadedBPMNModeler] = useState<boolean>(false);
    const [soloModal, setsoloModal] = useState<boolean>(false)
    const [showAgentModal, setShowAgentModal] = useState<boolean>(false)
    const [showActionModal, setShowActionModal] = useState<boolean>(false)
    const [agentDetails, setAgentDetails] = useState({ key: "", id: "" });
    const [actionDetails, setActionDetails] = useState<Partial<ActionDetails>>({})
    const [soloFlowId, setSoloFlowId] = useState("")
    const [soloFlowName, setSoloFlowName] = useState("")
    const [selectedSoloFlowRes, setSelectedSoloFlowResp] = useState({})

    const [xmlStack, setXMLStack] = useState<BPMNXMLStack>({ stackIdx: -1, xml: [] })
    const { info: onboardingInfo, guideVisible } = useSelector((state: AppState) => state.onboarding)

    // const [branch, setBranch]: any = useState("")
    // const [version, setversion]:any = useState("")
    // const [appName, setAppName]: any = useState("")
    const loggedInUserId = useSelector((state: any) => {
        return state.user.data.user.id
    })
    const isCheckedIn: boolean = resourceLock.userId === loggedInUserId;

    const orgPermissions: any = useSelector((state: any) => {
        return state.org.orgPermissions
    }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))

    const appPermissions: any = useSelector((state: any) => {
        return state.apps.selectedApp.permissions
    }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))

    const canEdit = currentVersion && isCheckedIn && (orgPermissions.includes('bpmn.Edit') || appPermissions.includes('bpmn.Edit'))

    const updateProperties = (id: string, updateDate: {}) => {
        const elementRegistry = bpmnModeler.current.get("elementRegistry"),
            modeling = bpmnModeler.current.get("modeling");
        const process = elementRegistry.get(id);
        if (process) {
            modeling.updateProperties(process, updateDate);
        }
    }

    const updateTaskKey = (id: string, key: string, service?: boolean, parameters?: Record<string, any>, integrationName?: string, isExternalAgent: boolean = false) => {
        if (id && key) {
            const elementRegistry = bpmnModeler.current.get("elementRegistry"),
                modeling = bpmnModeler.current.get("modeling");
            const Task = elementRegistry.get(id);
            logger.debug("modeling", modeling, Task, elementRegistry, elementRegistry.get(id));
            if (id.includes("solo")) {
                modeling.updateProperties(Task, {
                    type: "external",
                    topic: `soloTask:${key}`,
                });
            } else if (id.includes("aiAgent")) {
                modeling.updateProperties(Task, {
                    type: "external",
                    topic: `aiAgentTask`,
                    'camunda:aiAgentKey': isExternalAgent ? key.startsWith("uniphore:") ? key : `uniphore:${key}` : "a8studio:" + key
                });
            } else if (id.includes("action")) {
                modeling.updateProperties(Task, {
                    type: "external",
                    topic: `actionTask`,
                    'camunda:actionKey': "uniphore:" + integrationName + ":" + key
                });
                const filteredParameters = Object.keys(parameters || {});
                if (filteredParameters.length > 0) {
                    const a8Window: any = window;
                    a8Window[id] = filteredParameters;
                }
            } else if (service && !id.includes("solo") && !id.includes("aiAgent") && !id.includes("action")) {
                modeling.updateProperties(Task, {
                    type: "external",
                    topic: "a8studio:" + key,
                });
            } else {
                modeling.updateProperties(Task, {
                    formKey: "a8studio:" + key
                });
            }
        }
    }

    const refetchLockStatus = useCallback((callback?: any) => {
        Http.get(`/apps/${appId}/bpmn/${bpmnId}?versionId=${versionId}`).subscribe((res: any) => {
            // send resource lock data to header
            ResourceLock.sendMessage({
                message: 'FORM_REFETCHED',
                resourceLock: res[0].resourceLock || {},
                refetchedCallback: () => callback && callback(res[0].resourceLock)
            })
        })
    }, [appId, bpmnId, versionId]);

    function fetchingInitialProperties({ obj, findPosition, webhookPropertyTags, SoloPropertyTags }: any) {
        findPosition && findPosition.forEach((pos: any) => {
            if (pos) {
                if (pos.$.id.includes("solo") && pos.$["camunda:topic"] === "soloTask") {
                    if (pos["bpmn:extensionElements"] && pos["bpmn:extensionElements"][0]["camunda:properties"]) {
                        pos["bpmn:extensionElements"][0]["camunda:properties"][0]["camunda:property"].forEach((extension: any) => {
                            pos.$[SoloPropertyTags[extension.$.name] || extension.$.name] = extension.$.value
                        })
                    }
                } else if (pos.$.id.includes("webhook") && pos.$["camunda:topic"] === "webhook") {
                    if (pos["bpmn:extensionElements"]) {
                        pos["bpmn:extensionElements"][0]["camunda:properties"][0]["camunda:property"].forEach((extension: any) => {
                            pos.$[webhookPropertyTags[extension.$.name] || extension.$.name] = extension.$.value
                        })
                    }
                }
            }
        })
    }

    function subprocessIteration(processDetails: any) {
        const { obj, webhookPropertyTags, SoloPropertyTags } = processDetails;
        Object.keys(obj).forEach((items: any) => {
            if (items === "bpmn:serviceTask") {
                fetchingInitialProperties({ obj, findPosition: obj[items], webhookPropertyTags, SoloPropertyTags })
            } else if (items === "bpmn:subProcess") {
                subprocessIteration({ obj: obj[items][0], webhookPropertyTags, SoloPropertyTags })
            }
        })
    }

    const initialXmlDiagramParse = (xmlString: string) => {
        const SoloPropertyTags: any = {
            waitForCompletion: 'camunda:isStartableInTasklist',
            timeout: 'camunda:taskPriority_timeout',
            customerMobile: 'camunda:taskPriority_mobile',
            customerEmail: 'camunda:taskPriority_email'
        }
        const webhookPropertyTags: any = {
            webhookHandler: "camunda:handler_ssTypeFunc",
            webhookRequest: "camunda:request_ssTypeFunc"
        }
        let newXmlDiagram = null;
        let bpmnAppName = "";
        let bpmnAppId = "";
        parseString(xmlString, function (err: any, result: any) {
            bpmnAppName = result["bpmn:definitions"]["bpmn:process"][0]?.$?.name || ""
            bpmnAppId = result["bpmn:definitions"]["bpmn:process"][0]?.$?.id || ""
            let findPosition = result["bpmn:definitions"]["bpmn:process"][0]["bpmn:serviceTask"];
            let findBusinessRuleTask = result["bpmn:definitions"]["bpmn:process"][0]["bpmn:businessRuleTask"];
            findPosition && findPosition.forEach((pos: any) => {
                if (pos) {
                    if (pos.$.id.includes("solo") && pos.$["camunda:topic"] === "soloTask") {
                        if (pos["bpmn:extensionElements"] && pos["bpmn:extensionElements"][0]["camunda:properties"]) {
                            pos["bpmn:extensionElements"][0]["camunda:properties"][0]["camunda:property"].forEach((extension: any) => {
                                pos.$[SoloPropertyTags[extension.$.name] || extension.$.name] = extension.$.value
                            })
                        }
                    } else if (pos.$.id.includes("webhook") && pos.$["camunda:topic"] === "webhook") {
                        if (pos["bpmn:extensionElements"]) {
                            pos["bpmn:extensionElements"][0]["camunda:properties"][0]["camunda:property"].forEach((extension: any) => {
                                pos.$[webhookPropertyTags[extension.$.name] || extension.$.name] = extension.$.value
                            })
                        }
                    }
                }
            })

            const businessRuleTask = findBusinessRuleTask?.map((rule: any) => {
                if (rule?.$?.["camunda:dmnHub"]) {
                    const dmnName = rule.$["camunda:decisionRef"];
                    delete rule.$["camunda:decisionRef"];
                    return {
                        ...rule,
                        $: {
                            ...rule.$,
                            ["camunda:dmnHubName"]: dmnName
                        }
                    }
                } else {
                    return rule
                }
            })
            if (businessRuleTask?.length > 0) {
                result["bpmn:definitions"]["bpmn:process"][0]["bpmn:businessRuleTask"] = businessRuleTask;
            }
            let bpmnProcessObj = {
                ...result["bpmn:definitions"]["bpmn:process"][0]
            }
            subprocessIteration({ obj: bpmnProcessObj, webhookPropertyTags, SoloPropertyTags })

            if (bpmnProcessObj && Object.keys(bpmnProcessObj).length > 0) {
                result["bpmn:definitions"]["bpmn:process"][0] = bpmnProcessObj;
            }
            let builder = new Builder();
            newXmlDiagram = builder.buildObject(result);
        })
        return { newXmlDiagram, bpmnAppId, bpmnAppName };
    }

    const initialdata = useCallback((refetch = false, refetchCallback?: any) => {
        Http.get(`/apps/${appId}/bpmn/${bpmnId}?versionId=${versionId}`).subscribe(async (res: any) => {
            dispatch(updateSelectedBpmn(res));

            let lockData: any = {
                resourceLock: res[0].resourceLock
            }
            if (refetch) {
                lockData = {
                    ...lockData,
                    message: 'FORM_REFETCHED'
                }
            }
            if (refetchCallback) {
                lockData = {
                    ...lockData,
                    refetchedCallback: () => refetchCallback(res[0].resourceLock)
                }
            }
            // send resource lock data to header
            ResourceLock.sendMessage(lockData)

            // send resource lock data to header
            ResourceLock.sendMessage({
                resourceLock: res[0].resourceLock
            })

            setbpmndata(res)
            let initialXmldaigram = res.length > 0 && res[0].source ? res[0].source : initialDiagram
            const hasPreviousVersion = Boolean(previousVersionId)
            let Modeler = bpmnModeler.current;
            let { newXmlDiagram, bpmnAppId, bpmnAppName } = initialXmlDiagramParse(initialXmldaigram);
            const newXmlDiagramCheck = newXmlDiagram ? newXmlDiagram : ""
            let CheckHistime: boolean
            const parsedXML: any = parseString(newXmlDiagramCheck, function (err, result) {
                const processDefinition = result['bpmn:definitions']['bpmn:process'][0];
                const historyTimeToLive = "camunda:historyTimeToLive"
                const histValCheck = Object.keys(processDefinition.$).includes(historyTimeToLive)
                CheckHistime = histValCheck
                return result
            });
            await parsedXML
            let updateProcess = (id: string) => {
                // Update bpmn id and name only on initial version
                let DefaultUpdate = hasPreviousVersion ? {
                    isExecutable: true,
                    name: bpmnAppName ? bpmnAppName : res[0].appName,
                    id: bpmnAppId && !bpmnAppId.includes("Process_1") ? bpmnAppId : res[0].orgName + "_" + res[0].appName,
                    ...(CheckHistime ? {} : { "camunda:historyTimeToLive": "P30D" }),
                } : {
                    isExecutable: true,
                    name: res[0].appName,
                    id: res[0].orgName + "_" + res[0].appName,
                    ...(CheckHistime ? {} : { "camunda:historyTimeToLive": "P30D" }),
                }
                updateProperties(id, DefaultUpdate);
            }
            bpmnModeler.current.importXML(newXmlDiagram ? newXmlDiagram : initialXmldaigram, function (err: any) {
                if (err) {
                    logger.error("err", err);
                } else {
                    logger.debug("sucess");
                    updateProcess(Modeler._definitions.rootElements[0].id)
                    let element: any = document.getElementById("js-drop-zone");
                    element && element.classList.remove("with-error");
                    element && element.classList.add("with-diagram");
                }
            });
        }, (err) => {
            logger.error("initialData", err);
            const navigateTo = `/apps/list/${appId}/journey/list`;
            redirectOnError(history, err.message, navigateTo, "View all BPMN", "bpmnId")
        })
    }, [appId, bpmnId, versionId, dispatch, history])

    const saveSVGAsImage = async () => {
        try {
            const {
                svg
            } = await bpmnModeler.current.saveSVG();
            const svgBlob = new Blob([svg], { type: "image/svg+xml;charset=utf-8" });
            const url = URL.createObjectURL(svgBlob);
            const downloadLink = document.createElement("a");
            downloadLink.href = url;
            downloadLink.download = `${bpmndata.length > 0 && bpmndata[0]?.bpmnName}.svg`;
            downloadLink.click();
            URL.revokeObjectURL(url);
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        const subscriber = ResourceLock.getMessage().subscribe(({ message, callback }) => {
            if (message === 'BPMN_REFETCH') {
                initialdata(true, callback)
            } else if (message === 'BPMN_REFETCH_LOCK') {
                callback ? refetchLockStatus(callback) : refetchLockStatus()
            }
        })
        return () => subscriber.unsubscribe()
    }, [initialdata, refetchLockStatus])

    useEffect(() => {
        if (bpmnModeler && bpmnModeler.current) {
            bpmnModeler.current.setReadOnly(!isCheckedIn || !canEdit)
        }
    }, [isCheckedIn, canEdit, loadedBPMNModeler]);

    useEffect(() => {
        const subscriber = ResourceLock.getMessage().subscribe(({ resourceLock }) => {
            resourceLock ? setResourceLock(resourceLock) : setResourceLock({})
        })
        return () => subscriber.unsubscribe()
    }, [])

    useEffect(() => {
        getFunctions()
        //eslint-disable-next-line
    }, [])

    const getFunctions = () => {
        const appId = props.match.params.appId;
        Http.get(`/apps/${appId}/functions?versionId=${versionId}`).subscribe((serviceRes: any) => {
            let func = serviceRes.map((e: any) => {
                if (e.mode === "server") {
                    return {
                        value: e.displayName,
                        name: e.displayName
                    }
                }
                return null
            }).filter((e: any) => { return e })
            let initialFunc = [{
                value: "",
                name: ""
            }]
            let newWindow: any = window
            newWindow.serverSideFunction = [...initialFunc, ...func]
        });
    }

    const addExtension = (type: string, element: any) => {
        let newExtension = null;
        let saveFlow = true
        if (type === 'solo' && element) {
            let soloFlowName;
            let appId;
            let waitForCompletion;
            let timeout = element.$["camunda:taskPriority_timeout"];
            let mobileNumber = element.$["camunda:taskPriority_mobile"];
            let emailId = element.$[`camunda:taskPriority_email`];
            let topic = element.$[`camunda:topic`]
            let completion = element.$["camunda:isStartableInTasklist"]
            delete element.$["camunda:taskPriority_timeout"]
            delete element.$["camunda:isStartableInTasklist"]
            delete element.$["camunda:taskPriority_mobile"];
            delete element.$["camunda:taskPriority_email"];
            delete element.$["flowName"]
            delete element.$["camunda:taskPriority"]
            delete element.$["customerMobile"]
            delete element.$["customerEmail"]
            if (!mobileNumber || !emailId) {
                saveFlow = false
            } else {
                saveFlow = true
            }
            if (completion) {
                waitForCompletion = completion;
            }
            let extensionElements = element["bpmn:extensionElements"]
            if (topic && !extensionElements) {
                let splittopic = topic.split(":");
                soloFlowName = splittopic[1]?.split("_")[1];
                appId = splittopic[1]?.split("_")[0]
            } else if (topic) {
                let splitTopic = topic.split(":")
                if (splitTopic?.length > 0) {
                    soloFlowName = splitTopic[1]?.split("_")[1];
                    appId = splitTopic[1]?.split("_")[0]
                }
            }
            if (extensionElements && topic === "soloTask") {
                let findFlowName = extensionElements[0]["camunda:properties"][0]["camunda:property"][0].$.value
                let findAppId = extensionElements[0]["camunda:properties"][0]["camunda:property"][1].$.value
                if (findFlowName) {
                    if (soloFlowName !== findFlowName) {
                        soloFlowName = findFlowName
                        appId = findAppId
                    }
                }
            }
            element.$[`camunda:topic`] = "soloTask"
            let inputOutput: any = element['bpmn:extensionElements'] && element['bpmn:extensionElements'][0]['camunda:inputOutput'];
            let properties: any;
            properties = [{
                'camunda:property': [
                    {
                        $: {
                            name: "flowName",
                            value: soloFlowName
                        }
                    },
                    {
                        $: {
                            name: "appId",
                            value: appId
                        }
                    },
                    {
                        $: {
                            name: "waitForCompletion",
                            value: waitForCompletion || "false"
                        },
                    },
                    {
                        $: {
                            name: "customerMobile",
                            value: mobileNumber || ""
                        },
                    },
                    {
                        $: {
                            name: "customerEmail",
                            value: emailId || ""
                        },
                    }
                ]
            }];
            if (timeout && properties?.length) {
                properties = [{
                    "camunda:property": [
                        ...properties[0]["camunda:property"],
                        {
                            $: {
                                name: "timeout",
                                value: timeout || 0
                            },
                        },
                    ]
                }]
            }
            extensionElements = {};
            if (inputOutput) {
                // const convertedInputParam = inputParamsType("solo", inputOutput)
                extensionElements['camunda:inputOutput'] = inputOutput;
            }
            if (properties) {
                extensionElements['camunda:properties'] = properties;
            }
            newExtension = {
                'bpmn:extensionElements': [extensionElements]
            }
        } else if (type === 'webhook' && element) {
            let handler = element.$["camunda:handler_ssTypeFunc"]
            let request = element.$["camunda:request_ssTypeFunc"]
            delete element.$["camunda:handler_ssTypeFunc"]
            delete element.$["camunda:request_ssTypeFunc"]
            if (request || handler) {
                let properties: any;
                properties = [{
                    'camunda:property': [
                        {
                            $: {
                                name: "webhookHandler",
                                value: handler || ""
                            },
                        },
                        {
                            $: {
                                name: "webhookRequest",
                                value: request || ""
                            },
                        }]
                }];
                let extensionElements: any = {};

                if (properties) {
                    extensionElements['camunda:properties'] = properties;
                }
                newExtension = {
                    'bpmn:extensionElements': [extensionElements]
                }
            }
        }
        return {
            saveFlow,
            newExtension
        };
    }


    // const inputParamsType = (type: string, inputParam: any) => {
    //     let finalInputVariables = [];
    //     if (type === 'solo' && inputParam) {
    //         if (inputParam[0]["camunda:inputParameter"]) {
    //             let inputParameters = inputParam[0]["camunda:inputParameter"]
    //             finalInputVariables = inputParameters.map((ele: any) => {
    //                 if (ele?._) {
    //                     const num = /^-?\d+(\.\d+)?$/;
    //                     const booleanPattern = /^(true|false)$/i;
    //                     if (num.test(ele._)) {
    //                         return {
    //                             $: {
    //                                 name: ele.$.name,
    //                                 type: "Integer",
    //                             },
    //                             _: ele._
    //                         }
    //                     } else if (booleanPattern.test(ele._.toLowerCase())) {
    //                         return {
    //                             $: {
    //                                 name: ele.$.name,
    //                                 type: "Boolean",
    //                             },
    //                             _: ele._
    //                         }
    //                     } else {
    //                         return {
    //                             $: {
    //                                 name: ele.$.name,
    //                                 type: "String",
    //                             },
    //                             _: ele._
    //                         }
    //                     }
    //                 } else {
    //                     return ele
    //                 }
    //             })
    //         }
    //     }
    //     inputParam[0]["camunda:inputParameter"] = finalInputVariables
    //     return inputParam
    // }




    function addExtensionOnServiceTasks(props: any) {
        let { obj, saveEnable, addExtensioninSolo } = props
        if (obj && obj['bpmn:serviceTask']) {
            obj['bpmn:serviceTask'] = obj['bpmn:serviceTask']?.map((el: any) => {
                if (el.$.id.includes("solo")) {
                    if (el.$.appId) {
                        delete el.$.appId
                    }
                    const { newExtension: addNewextension, saveFlow } = addExtension('solo', el);
                    saveEnable = saveFlow
                    if (addNewextension) {
                        if (el["bpmn:extensionElements"]) {
                            delete el["bpmn:extensionElements"]
                        }
                        return addExtensioninSolo = {
                            ...addNewextension,
                            ...el,
                        }
                    } else {
                        return addExtensioninSolo = {
                            ...el
                        }
                    }
                } else if (el.$.id.includes("webhook")) {
                    const { newExtension: addNewextension, saveFlow } = addExtension('webhook', el);
                    saveEnable = saveFlow
                    if (addNewextension) {
                        if (el["bpmn:extensionElements"]) {
                            delete el["bpmn:extensionElements"]
                        }
                        return addExtensioninSolo = {
                            ...addNewextension,
                            ...el,
                        }
                    } else {
                        return addExtensioninSolo = {
                            ...el
                        }
                    }
                } else {
                    return el;
                }
            })
        }
    }


    function iterateSubProcess(bpmnDetails: any) {
        const { obj, saveEnable, addExtensioninSolo } = bpmnDetails;
        Object.keys(obj).forEach((items) => {
            if (items === 'bpmn:serviceTask') {
                addExtensionOnServiceTasks({ obj, findPosition: obj[items], saveEnable, addExtensioninSolo })
            } else if (items === "bpmn:subProcess") {
                if (obj[items].length === 1) {
                    iterateSubProcess({ obj: obj[items][0], saveEnable, addExtensioninSolo })
                } else {
                    for (let i of obj[items]) {
                        iterateSubProcess({ obj: i, saveEnable, addExtensioninSolo })
                    }
                }
            }
        })
    }

    const bpmnXmlParse = (xmlString: string) => {
        let xml = null;
        let addExtensioninSolo: any;
        let saveEnable = true
        parseString(xmlString, function (err, result) {
            let findBusinessRule = result["bpmn:definitions"]["bpmn:process"][0]["bpmn:businessRuleTask"];
            let businessTask;
            let bpmnProcessObj = {
                ...result["bpmn:definitions"]["bpmn:process"][0]
            }
            iterateSubProcess({ obj: bpmnProcessObj, saveEnable, addExtensioninSolo })

            // eslint-disable-next-line
            logger.debug("extension", addExtensioninSolo)
            if (bpmnProcessObj && Object.keys(bpmnProcessObj).length > 0) {
                if (result["bpmn:definitions"]["bpmn:process"][0]['bpmn:extensionElements']) {
                    delete result["bpmn:definitions"]["bpmn:process"][0]['bpmn:extensionElements']
                }
                result["bpmn:definitions"]["bpmn:process"][0] = bpmnProcessObj;
            }

            if (findBusinessRule?.length) {
                businessTask = findBusinessRule?.map((el: any) => {
                    if (el?.$?.["camunda:dmnHubName"]) {
                        const dmnName = el.$["camunda:dmnHubName"];
                        delete el.$["camunda:dmnHubName"];
                        return {
                            ...el,
                            $: {
                                ...el.$,
                                ["camunda:dmnHub"]: "true",
                                ["camunda:decisionRef"]: dmnName
                            }

                        }
                    } else {
                        return el
                    }
                })
            }

            if (businessTask?.length > 0) {
                result["bpmn:definitions"]["bpmn:process"][0]["bpmn:businessRuleTask"] = businessTask;
            }

            let builder = new Builder();
            xml = builder.buildObject(result);
        });
        return {
            saveEnable,
            xml
        };
    }
    const save = useCallback((isCommit: boolean, discard?: boolean) => {
        if (bpmndata && bpmndata.length > 0) {
            bpmnModeler.current.saveXML({ format: true }, function (_err: any, xml: any) {
                const { xml: formattedXml, saveEnable } = bpmnXmlParse(xml)
                const { bpmnName } = bpmndata[0]
                const data = {
                    // name: bpmnName,
                    appId: appId,
                    source: formattedXml
                }
                logger.debug("xml" + formattedXml)
                if (saveEnable) {
                    Http.put(`/bpmn/${bpmnId}?isCommit=${isCommit}${discard ? '&discard=true' : ''}`, data).subscribe((formRes) => {
                        if (isCommit) {
                            SuccessToast('Journey committed successfully');
                            initialdata()
                        } else {
                            SuccessToast('Journey saved successfully');
                        }
                    }, (err) => {
                        ErrorToast('Journey save failed');
                    })
                } else {
                    ErrorToast('Mobile number or EmailId required to save solo task');
                }
            });
        }
        // eslint-disable-next-line
    }, [appId, bpmnId, bpmndata, SuccessToast, ErrorToast, initialdata])

    useEffect(() => {
        if (bpmnActionType && bpmnModeler && bpmnModeler.current) {
            const commandStack = bpmnModeler.current.get("commandStack");
            if (bpmnActionType === "SAVE") {
                save(false);
            } else if (bpmnActionType === 'DISCARD') {
                save(true, true)
            } else if (bpmnActionType === "COMMIT") {
                save(true);
            } else if (bpmnActionType === "UNDO") {
                if (commandStack.canUndo()) {
                    commandStack.undo();
                } else if (xmlStack.stackIdx !== 0 && xmlStack.xml.length > 1) {
                    const currentStackIdx = xmlStack.stackIdx - 1;
                    const xml = xmlStack.xml[currentStackIdx];
                    bpmnModeler.current.importXML(xml, (error: any) => {
                        if (!error) {
                            setXMLStack((prev) => ({ ...prev, stackIdx: currentStackIdx }));
                        } else {
                            logger.error("failed to import xml on undo:", error);
                        }
                    });
                }
            } else if (bpmnActionType === "REDO") {
                if (commandStack.canRedo()) {
                    commandStack.redo();
                } else if (xmlStack.stackIdx !== -1) {
                    const currentStackIndex = xmlStack.stackIdx + 1;
                    if (currentStackIndex < xmlStack.xml.length) {
                        const xml = xmlStack.xml[currentStackIndex];
                        bpmnModeler.current.importXML(xml, (error: any) => {
                            if (!error) {
                                setXMLStack((prev) => ({ ...prev, stackIdx: currentStackIndex }));
                            } else {
                                logger.error("failed to import xml on redo:", error);
                            }
                        });
                    }
                }
            } else if (bpmnActionType === "DOWNLOAD") {
                saveSVGAsImage()
            }
            dispatch(onBpmnAction(null));
        }
    }, [bpmnActionType, dispatch, save]);

    const getSavedForm = async (savedForm: any, select?: string) => {
        logger.debug("saved from", savedForm);
        const form = savedForm[0]
        const isV2Form = form.hasOwnProperty('is_v2') ? form.is_v2 : form.isV2
        setvisible(false)
        updateTaskKey(userTaskId, select === "select" ? form.formKey : form.form_key)
        if (!guideVisible) {
            window.open(`#/apps/list/${select === "select" ? form.appId : form.app_id}/assist/forms/list/${select === "select" ? form.formId : form.form_id}/${isV2Form ? 'createv2' : 'create'}`)
            isV2Form && localStorage.setItem(`fromAssisted:${select === "select" ? form.formId : form.form_id}`, "true")
        }
    }
    const getService = (res: any, select?: string) => {
        setserviceVisible(false)
        logger.debug("res in bpmn index", res);
        updateTaskKey(serviceTaskId, select === "select" ? res[0].serviceKey : res[0].service_key, true)
        if (!guideVisible) {
            window.open(`#/apps/list/${select === "select" ? res[0].appId : res[0].app_id}/assist/service/list/${select === "select" ? res[0].id : res[0].service_id}/create`)
        }
    }

    const getSoloService = (res: any, select?: string) => {
        setserviceVisible(false)
        logger.debug("res in bpmn index", res);
        updateTaskKey(serviceTaskId, select === "select" ? res[0].serviceKey : res[0].service_key, true)
        window.open(`#/apps/list/${select === "select" ? res[0].appId : res[0].app_id}/solo/service/list/${select === "select" ? res[0].id : res[0].service_id}/create`)
    }

    const getSoloFlows = (res: any, appId: any, select?: string, openSoloFLow?: any) => {
        setsoloModal(false)
        setSoloFlowName(res && res.name)
        logger.debug("res in bpmn", res);
        dispatch(selectedSolo(res))
        updateTaskKey(serviceTaskId, appId + "_" + res.name, true)
        if (openSoloFLow) {
            window.open(`#/apps/list/${select === "select" ? appId : appId}/journey/solo/list/${select === "select" ? res.id : res && res.id}/create`)
        }
    }

    useEffect(() => {

        bpmnModeler.current = new BpmnModeler({
            container: "#js-canvas",
            linting: {
                bpmnlint: bpmnlintConfig
            },
            propertiesPanel: {
                parent: '#js-properties-panel'
            },
            additionalModules: [
                propertiesPanelModule,
                propertiesProviderModule,
                lintModule
                // {
                //     __init__: ["eventBusLogger"],
                //     eventBusLogger: ["type", EventBusLogger]
                // }
            ],
            moddleExtensions: {
                camunda: camundaModdleDescriptor
            }
        });

        const linting = bpmnModeler.current.get('linting');
        linting._active = true
        linting._button.setAttribute("disabled", true)
        setLoadedBPMNModeler(true);

        let Visiblity = (visible: boolean, formKey: string, userTaskId: string) => {
            setvisible(visible);
            setformKey(formKey);
            setuserTaskId(userTaskId);
        }
        let serviceVisiblity = (visible: boolean, servicekey: string, serviceId: string) => {
            setserviceVisible(visible)
            setservicekey(servicekey);
            setserviceTaskId(serviceId);
        }

        let soloVisibility = (visible: boolean, topic: string, soloId: string) => {
            setsoloModal(visible);
            dispatch(selectedJourney("solo"))
            setSoloFlowId(topic);
            setserviceTaskId(soloId);
        }

        let agentListVisibility = (visible: boolean, topic: string, agentId: string) => {
            setShowAgentModal(visible);
            setserviceTaskId(agentId);
        }

        let actionsListVisibility = (visible: boolean, topic: string, actionName: string, id: string) => {
            setShowActionModal(visible);
            setserviceTaskId(actionName);
        }
        bpmnModeler.current.get('eventBus').on('element.click', (event: any) => {
            const { guideVisible, info } = store.getState().onboarding;
            const { type } = event.element;
            if (guideVisible) {
                if (type === 'bpmn:StartEvent') {
                    dispatch(setStepIndex(info.stepIndex + 1))
                }
                if (type === 'bpmn:SequenceFlow') {
                    dispatch(setStepIndex(info.stepIndex + 1))
                }
                if (type === 'bpmn:ExclusiveGateway') {
                    dispatch(setStepIndex(info.stepIndex + 1))
                }
            }
        })

        bpmnModeler.current.get('eventBus').on('popupMenu.getProviders.bpmn-replace', (event: any) => {
            const { guideVisible, steps, info } = store.getState().onboarding
            // findout the next step is bpmn_user_task_settings
            if (guideVisible && steps && steps[info.stepIndex] && steps[info.stepIndex].selector === '.bpmn_contextpad_setting') {
                dispatch(setStepIndex(info.stepIndex + 1))
            }
        })

        bpmnModeler.current.get('eventBus').on('commandStack.shape.create.postExecute', (event: any) => {
            logger.debug("event--->", event);
            const { guideVisible, info } = store.getState().onboarding;

            if (guideVisible) {
                if (event.context.shape.type === 'bpmn:ExclusiveGateway') {
                    dispatch(setStepIndex(info.stepIndex + 1))
                }
                if (event.context.shape.type === 'bpmn:ServiceTask' && guideVisible) {
                    dispatch(setStepIndex(info.stepIndex + 1))
                }
                if (event.context.shape.type === 'bpmn:EndEvent' && guideVisible) {
                    dispatch(setStepIndex(info.stepIndex + 1))
                }
                if (event.context.shape.type === 'bpmn:Task') {
                    setTimeout(() => {
                        if (document.querySelector('.djs-direct-editing-parent')) {
                            document.querySelector('.djs-direct-editing-parent')?.classList.add("bpmn_task_editing_text")
                            dispatch(setStepIndex(store.getState().onboarding.info.stepIndex + 1))
                        }
                    }, 0)
                }
            }

            if (event.context.shape.type === 'bpmn:UserTask') {
                // eslint-disable-next-line
                updateProperties(event.context.shape.id, { 'camunda:assignee': "${startedBy}" })
                if (guideVisible) {
                    dispatch(setStepIndex(info.stepIndex + 1))
                }
            } if (event.context.shape.a8Type === 'solo') {
                updateProperties(event.context.shape.id, {
                    type: "external",
                    topic: `soloTask:${soloFlowName && soloFlowName}`,
                    id: event.context.shape.id + "_solo",
                    name: "soloTask"
                })
            }
            if (event.context.shape.a8Type === 'aiAgent') {
                updateProperties(event.context.shape.id, {
                    type: "external",
                    topic: `aiAgentTask`,
                    id: event.context.shape.id + "_aiAgent",
                    name: "aiAgent"
                })
            }
            if (event.context.shape.a8Type === 'action') {
                updateProperties(event.context.shape.id, {
                    type: "external",
                    topic: `actionTask`,
                    id: event.context.shape.id + "_action",
                    name: "Action",
                })
            }
            if (event.context.shape.a8Type === 'webhook') {
                updateProperties(event.context.shape.id, {
                    type: "external",
                    topic: "webhook",
                    id: event.context.shape.id + "_webhook",
                    name: "webhook"
                })
            }
        })

        var priority = 10000;
        bpmnModeler.current.get('eventBus').on('element.dblclick', priority, (event: any) => {
            const { guideVisible, info } = store.getState().onboarding;
            const { type } = event.element;
            if (guideVisible && (type === 'bpmn:UserTask' || type === 'bpmn:ServiceTask')) {
                dispatch(setStepIndex(info.stepIndex + 1))
            }
            if (event.element.type === 'bpmn:UserTask') {
                var bo = getBusinessObject(event.element);
                let formKey: string = bo.get('camunda:formKey') && bo.get('camunda:formKey').split(":").slice(1).join(':')
                if (formKey && currentVersion) {
                    Http.get(`/apps/${appId}/forms?versionId=${versionId}&branchId=${branchId}`).subscribe((formRes: any) => {
                        let selectedForm: any[] = formRes.filter((form: any) => form.formKey === formKey)
                        if (selectedForm.length > 0) {
                            Visiblity(true, formKey, event.element.id)
                        }
                        else {
                            Visiblity(true, "", event.element.id)
                        }
                    });
                } else if (currentVersion) {
                    Visiblity(true, "", event.element.id)
                }
                return false;
            }
            if (event.element.type === 'bpmn:ServiceTask' && event.element.id.search("_solo") === -1 && event.element.id.search("_webhook") === -1 && event.element.id.search("_aiAgent") === -1 && event.element.id.search("_action") === -1) {
                var servicebo = getBusinessObject(event.element);
                let topic: string = servicebo.get('camunda:topic') && servicebo.get('camunda:topic').split(":").slice(1).join(':');
                dispatch(selectedServices("Assisted"))
                if (topic && currentVersion) {
                    Http.get(`/apps/${appId}/services?versionId=${versionId}&branchId=${branchId}`).subscribe((formRes: any) => {
                        let selectedForm: any[] = formRes.filter((form: any) => form.serviceKey === topic)
                        if (selectedForm.length > 0) {
                            serviceVisiblity(true, topic, event.element.id)
                        }
                        else {
                            serviceVisiblity(true, "", event.element.id)
                            logger.debug("Formkey is not there");
                        }
                    });
                } else if (currentVersion) {
                    serviceVisiblity(true, "", event.element.id)
                }
                return false;
            } if (event.element.id.search("_solo") > 0) {
                var soloFlows = getBusinessObject(event.element);
                let extensionElements = soloFlows.get("bpmn:extensionElements")
                var servicebo = getBusinessObject(event.element);
                let soloTopic: string = servicebo.get('camunda:topic') && servicebo.get('camunda:topic').split(":");
                let topic: any;
                if (soloTopic?.length > 1) {
                    setSelectedSoloFlowResp({
                        id: soloTopic.length > 0 ? soloTopic[1]?.split("_")[0] : "",
                        name: soloTopic.length > 0 ? soloTopic[1]?.split("_")[1] : ""
                    })
                    topic = soloTopic
                } else if (extensionElements?.values[0]?.values) {
                    setSelectedSoloFlowResp({
                        id: extensionElements?.values[0]?.values[1]?.value || "",
                        name: extensionElements?.values[0]?.values[0]?.value || ""
                    })
                    topic = soloTopic
                } else if (extensionElements?.values[1]?.values) {
                    setSelectedSoloFlowResp({
                        id: extensionElements?.values[1]?.values[1]?.value || "",
                        name: extensionElements?.values[1]?.values[0]?.value || ""
                    })
                    topic = soloTopic
                }
                if (topic && currentVersion) {
                    Http.get(`/apps/${appId}/solo-flows?versionId=${versionId}`).subscribe((formRes: any) => {
                        let selectedFlow: any[] = formRes.flows.filter((soloFlow: any) => soloFlow.name === topic)
                        if (selectedFlow.length > 0) {
                            soloVisibility(true, selectedFlow[0].id, event.element.id)
                        }
                        else {
                            soloVisibility(true, "", event.element.id)
                        }
                    })
                } else if (currentVersion) {
                    soloVisibility(true, "", event.element.id)
                }
            }
            if (event.element.id.search("_aiAgent") > 0) {
                const servicebo = getBusinessObject(event.element);
                let agentKey = servicebo.get("camunda:aiAgentKey")?.split("a8studio:")[1]

                if (!agentKey) {
                    agentKey = servicebo.get("camunda:aiAgentKey")?.split("uniphore:")[1]
                }
                setAgentDetails({ key: agentKey, id: "" })
                agentListVisibility(true, "", event.element.id)
            }

            if (event.element.id.search("_action") > 0) {
                const servicebo = getBusinessObject(event.element);
                const actionKeys = servicebo.get("camunda:actionKey")?.split(":") || []
                setActionDetails({
                    id: event.element.id,
                    type: "action",
                    function: {
                        description: "",
                        name: actionKeys.length ? actionKeys[1] : "",
                        integration_name: actionKeys.length ? actionKeys[2] : "",
                    },
                    selectedActionName: actionKeys.length ? `${actionKeys[2]}${actionKeys[1]}` : "",

                })
                // setActionDetails({ id: event.element.id, name: actionKeys.length ? actionKeys[1] : "", integrationName: actionKeys.length ? actionKeys[2] : "", id: "" })
                actionsListVisibility(true, "", event.element.id, servicebo?.id)
            }
        });
        initialdata();
        // eslint-disable-next-line
    }, [versionId, currentVersion, appId, branchId, initialdata, bpmnModelerInstance, dispatch])

    logger.debug("bpmn reander trigger");
    return (
        <div className='viewWrapper'>
            {/* <div style={{ marginTop: "-15px" }}> */}
            {/* <div data-test-id="bpmn_download_diagram" id="js-download-diagram" className="upper-nav-bar">

                    <div data-test-id="bpmn_paste" className="icons">
                        <Tooltip placement="bottomLeft" title={"paste"}>
                            <img src={paste} alt="simple"
                            />
                        </Tooltip>
                    </div>
                    <div data-test-id="bpmn_undo" className="icons" onClick={handleUndo}>
                        <Tooltip placement="bottomLeft" title={"undo"}   >
                            <img src={undo} alt="simple"
                            />
                        </Tooltip>
                    </div>

                    <div data-test-id="bpmn_redo" className="icons" onClick={handleRedo} >
                        <Tooltip placement="bottomLeft" title={"redo"}>
                            <img src={unselected_redo} alt="simple"
                            />
                        </Tooltip>
                    </div>
                    <div data-test-id="bpmn_copy" className="icons">
                        <Tooltip placement="bottomLeft" title={"copy"}>
                            <img src={copy} alt="simple"
                            />
                        </Tooltip>
                    </div>
                    {currentVersion && (
                        <div data-test-id="bpmn_save" className="icons" onClick={download}>
                            <Tooltip placement="bottomLeft" title={"save"}>
                                <img src={saveIcon} alt="simple"
                                />
                            </Tooltip>
                        </div>
                    )} */}
            {/* </div> */}
            <div data-test-id="bpmn_drop_zone" className="content" id="js-drop-zone">
                <div data-test-id="canvas" style={{ height: "calc(100vh - 65px)" }} className="canvas" id="js-canvas"></div>
                <div data-test-id="properties_panel" className="properties-panel-parent" id="js-properties-panel" style={{ overflow: "auto" }}></div>
            </div>
            {visible &&
                <FormModal
                    data-test-id="bpmn_saved_form"
                    visible={visible}
                    getSavedForm={getSavedForm}
                    appVersion={appVersion!}
                    selectedFromKey={formKey}
                    appId={appId}
                    branchId={branchId}
                    setvisible={(status: boolean) => {
                        setvisible(status)

                    }}
                ></FormModal>
            }
            {serviceVisible &&
                <ServiceModal
                    data-test-id="bpmn_srvice"
                    visible={serviceVisible}
                    appVersion={appVersion!}
                    selectedKey={servicekey}
                    getService={getService}
                    getSoloService={getSoloService}
                    appId={appId}
                    branchId={branchId}
                    setvisible={(status: boolean) => {
                        logger.debug("set visible in bpmn", status);
                        setserviceVisible(status)
                    }}
                ></ServiceModal>
            }
            {soloModal &&
                <SoloModal
                    data-test-id="solo_modal"
                    visible={soloModal}
                    appVersion={appVersion!}
                    selectedSolo={soloFlowId}
                    appId={appId}
                    branchId={branchId}
                    setSelectedSoloFlowResp={setSelectedSoloFlowResp}
                    soloFlowResp={selectedSoloFlowRes}
                    getSoloFlows={getSoloFlows}
                    setvisible={(status: boolean) => {
                        logger.debug("set visible in bpmn", status);
                        setsoloModal(status)
                    }}
                >
                </SoloModal>

            }
            {showAgentModal &&
                <AgentListModal
                    appType="assisted"
                    setVisible={setShowAgentModal}
                    setSelectedAgent={setAgentDetails}
                    updateAgentDetails={setAgentDetails}
                    updateTask={updateTaskKey}
                    serviceId={serviceTaskId}
                    selectedAgent={agentDetails}
                    appId={appId}
                    versionId={versionId}
                    branchId={branchId}
                />
            }
            {showActionModal &&
                <ActionModal
                    setVisible={setShowActionModal}
                    setActionDetails={setActionDetails}
                    updateTaskKey={updateTaskKey}
                    actionDetails={actionDetails}
                    serviceId={serviceTaskId}
                    appId={appId}
                    versionId={versionId}
                    branchId={branchId}
                    visible={showActionModal}
                />
            }
            <BPMNTars
                bpmnModeler={bpmnModeler}
                setXMLStack={setXMLStack}
            />
        </div>
    );
}


export default Assist;
